export const MAX_ADDITIONAL_PRICE = 100000;

export const normalizeAdditionalPrice = (value) => {
  if (value === null || value === undefined || value === "") return null;
  const amount = Number(value);
  return Number.isFinite(amount) &&
    amount >= 1 &&
    amount <= MAX_ADDITIONAL_PRICE
    ? amount
    : null;
};

export const buildInterventionClosureBody = ({
  selectedFlux,
  description,
  additionalPrice,
}) => {
  const body = {ended_byTech: true, report: description};
  if (selectedFlux !== 1) return body;

  const normalizedPrice = normalizeAdditionalPrice(additionalPrice);
  if (normalizedPrice === null) {
    throw new RangeError(
      "Les frais supplémentaires doivent être compris entre 1 € et 100 000 €",
    );
  }
  return {...body, additionalPrice: normalizedPrice};
};
